import {
  FETCH_NVBUGS,
  FETCH_NVBUGS_START,
  FETCH_NVBUGS_SUCCESS,
  FETCH_NVBUGS_ERROR,
  UPDATE_NVBUGS,
  ADD_TABLE_FILTER,
  ADD_TABLE_SORT,
  CLEAR_FILTERS
} from './constants'

const fetchNvbugs = (id) => ({ type: FETCH_NVBUGS, id })
const fetchNvbugsStart = () => ({ type: FETCH_NVBUGS_START })
const fetchNvbugsSuccess = () => ({ type: FETCH_NVBUGS_SUCCESS })
const fetchNvbugsError = (error) => ({ type: FETCH_NVBUGS_ERROR, error })

const updateNvbugs = (data) => ({ type: UPDATE_NVBUGS, data })

const addTableFilter = (key, val) => ({ type: ADD_TABLE_FILTER, key, val })
const addTableSort = (key, val) => ({ type: ADD_TABLE_SORT, key, val })
const clearFilters = () => ({ type: CLEAR_FILTERS })


export {
  fetchNvbugs,
  fetchNvbugsStart,
  fetchNvbugsSuccess,
  fetchNvbugsError,
  updateNvbugs,
  addTableFilter,
  addTableSort,
  clearFilters
}
